/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
'use memo';

import styles from './signinIcon.module.scss';
import azCommonStyles from '@/theme/globals.module.scss';
import cx from 'classnames';

type SignInIconProps = {
  isFixedHeader?: boolean;
  mainLabel: string;
  className: string;
};

export function SignInIcon({ mainLabel, isFixedHeader = false, className }: SignInIconProps) {
  return (
    <div
      className={cx({
        [styles.fixedSignInMobileIconAndLabel]: isFixedHeader,
        [className]: className,
      })}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src="/images/signin.svg" alt="" width={20} height={20} decoding="async" />
      <span className={cx(azCommonStyles['az-caption'], styles.signInMobileLabel)}>
        {mainLabel}
      </span>
    </div>
  );
}
